import type { ReactElement } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { asset } from '@/utils/asset';

interface TeamMember {
  name: string;
  role: string;
  image?: string;
  links?: {
    linkedin?: string;
    email?: string;
    github?: string;
    website?: string;
  };
}

const teamMembers: TeamMember[] = [
  {
    name: 'Clio Andris',
    role: 'Lab Director',
    image: asset('team/clio-andris.jpg'),
  },
  {
    name: 'Benjamin Wilson-Langman',
    role: 'Research Developer',
    image: asset('team/benjamin-wilson-langman.jpg'),
  },
  {
    name: 'Ashu Gupta',
    role: 'Research Developer',
    image: asset('team/ashu-gupta.jpg'),
  },
  {
    name: 'Cameron Owens',
    role: 'Research Developer',
    image: asset('team/cameron-owens.jpg'),
    links: {
      linkedin: 'https://www.linkedin.com/in/camcowens/',
      github: 'https://github.com/camcowens',
    },
  },
  {
    name: 'Jason Cox',
    role: 'Research Developer',
    image: asset('team/jason-cox.jpg'),
  },
];

export default function Team(): ReactElement {
  return (
    <Container className="py-4">
      <Row className="mb-4">
        <Col>
          <h1>Our Team</h1>
        </Col>
      </Row>
      <Row className="g-4">
        {teamMembers.map((member, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3}>
            <div className="team-card team-card-compact">
              <div className="team-card-img">
                {member.image ? (
                  <img src={member.image} alt={member.name} />
                ) : (
                  <i className="bi bi-person-circle"></i>
                )}
              </div>
              <div className="team-card-body">
                <div className="team-card-name">{member.name}</div>
                <div className="team-card-role">{member.role}</div>
                {member.links && (
                  <div className="team-card-links">
                    {member.links.linkedin && (
                      <a
                        href={member.links.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} LinkedIn`}
                      >
                        <i className="bi bi-linkedin"></i>
                      </a>
                    )}
                    {member.links.email && (
                      <a href={`mailto:${member.links.email}`} aria-label={`Email ${member.name}`}>
                        <i className="bi bi-envelope"></i>
                      </a>
                    )}
                    {member.links.github && (
                      <a
                        href={member.links.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} GitHub`}
                      >
                        <i className="bi bi-github"></i>
                      </a>
                    )}
                    {member.links.website && (
                      <a
                        href={member.links.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} Website`}
                      >
                        <i className="bi bi-globe"></i>
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
